/* eslint-disable no-restricted-globals */

const formatter = new Intl.NumberFormat('en-GB');

export function isNumeric(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
}

export function format(number) {
    return formatter.format(number).replace(/,/g, ' ');
}

// remaps a number to a percantage string, where 0-1 is 0-100%
export function toPercentageStr(number, fixed = 2) {
    return `${(number * 100).toFixed(fixed)}%`;
}

export function stringToNumber(value) {
    return value && !Number.isNaN(Number(value)) ? Number(value) : undefined;
}
